module.exports = __webpack_public_path__ + "static/media/06_tn.08765fee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/06_tn.jpg
// module id = 315
// module chunks = 0